<template>
  <div class="scs-contact-name-and-photo">
    <!-- todo : replace with profile picture component -->
    <ProfilePicture
      class="profile-picture"
      :contact="contact"
      :profilePicture="contact ? contact.profilePicture : undefined"
    />
    <div class="name" v-if="contact">
      <p>{{ contact.given_name }}</p>
      <p>{{ contact.family_name }}</p>
    </div>
    <div class="name" v-if="!contact">
      <p class="skeleton"></p>
      <p class="skeleton"></p>
    </div>
  </div>
</template>
<script>
import ProfilePicture from "./ProfilePicture.vue";
export default {
  data() {
    return {};
  },
  computed: {},
  methods: {},
  created() {},
  components: { ProfilePicture },
  props: ["contact"],
};
</script>
<style scoped>
.scs-contact-name-and-photo {
  display: flex;
  align-items: center;
  text-align: left;
  justify-content: flex-start;
}

/* todo : delete below css after replacing with component */
.profile-picture {
  margin-right: 10px;
  border-radius: 20px;
  /* background-color: var(--secondaryColor); */
}

p {
  margin: 0px;
  font-weight: 500;
  font-size: 0.65em;
}

.skeleton {
  width: 50px;
  height: 0.7em;
  background-color: var(--secondaryColor);
  margin: 5px 0px;
}
</style>
